module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard":"Dashboard","events":"Events","statistics":"Statistics","vibrational":"Vibrational","deflection":"Deflection"},"it":{"dashboard":"Dashboard","events":"Eventi","statistics":"Statistiche","vibrational":"Vibrazionale","deflection":"Deformata"}}')
  delete Component.options._Ctor
}
